import React, { forwardRef, Ref } from 'react';
import styled from 'styled-components';
import { typography } from '../../theme/typography';
import { css, style } from '../../utils/css';
import FormControl, { FormControlProps } from '../FormControl/FormControl';
import InputBase, { InputBaseProps } from '../InputBase/InputBase';

type TextAreaProps = Omit<
  FormControlProps &
    InputBaseProps &
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  'children' | 'cursor'
> & {
  inputComponent?: React.ElementType | string;
};

const StyledInput = styled.textarea<{ $dense?: boolean }>(
  {},
  css`
    background: white;
    appearance: none;
    --webkit-appearance: none;
    border: none;
    display: block;
    width: 100%;
    align-self: stretch;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0;

    &:focus {
      outline: none;
    }

    &:disabled {
      background: none;
    }
  `,
  style(typography.body),
  ({ $dense }) => style({ px: 2, py: $dense ? 1.5 : 2, borderRadius: 'base' }),
);

const TextArea = forwardRef(
  (
    {
      title,
      disabled,
      error,
      helperText,
      optional,
      dense,
      startIcon,
      endIcon,
      inputComponent = 'textarea',
      ...props
    }: TextAreaProps,
    ref: Ref<HTMLTextAreaElement>,
  ) => {
    return (
      <FormControl {...{ title, disabled, error, helperText, optional }}>
        <InputBase
          variableHeight
          noPadding
          cursor="text"
          {...{ dense, startIcon, endIcon, disabled, error }}
        >
          <StyledInput
            ref={ref}
            as={inputComponent}
            {...props}
            $dense={dense}
            disabled={disabled}
          />
        </InputBase>
      </FormControl>
    );
  },
);

TextArea.displayName = 'TextArea';
export default TextArea;
